import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button';
import { FormGroup, LabeledTextInput } from '../../../generic/Forms';
import type { PubServer } from '../../../../../typings/common';

type ServerProps = Pick<PubServer, 'id' | 'url' | 'token' | 'hasToken'> & {
  onUpdateServer: <K extends keyof PubServer>(
    member: K,
    value: PubServer[K],
  ) => void;
  onRemove: () => void;
};

/**
 * Pub settings Server row.
 */
const Server: VoidFunctionComponent<ServerProps> = ({
  id,
  url,
  token,
  hasToken,
  onUpdateServer,
  onRemove,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm" baselineAlignment>
      <LabeledTextInput
        label="ID"
        value={id || ''}
        size="small"
        onChange={value => onUpdateServer('id', value)}
        placeholder="foo"
      />
      <LabeledTextInput
        label="URL"
        value={url || ''}
        size="small"
        onChange={value => onUpdateServer('url', value)}
        placeholder="https://example.com/foo"
      />
      <LabeledTextInput
        label="Token"
        value={hasToken ? '••••••••' : token?.value || ''}
        size="small"
        onChange={value => {
          // We store passwords and sensitive data as a FetcherConfigSecret (typings/auth.d.ts)
          onUpdateServer(
            'token',
            {
              __type: 's',
              value,
            },
          );
        }}
        placeholder="••••••••"
      />
      <Button
        type="error"
        size="small"
        onClick={onRemove}
      >
        Remove
      </Button>
    </FormGroup>
  </div>
);

export default Server;
